module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/next-66a68faaa9a896f1a0ebc27a8e72cdb1.png";